var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _c(
        "div",
        { staticClass: "content_box" },
        [
          _c(
            "el-row",
            { staticStyle: { margin: "5px 0" } },
            [
              _vm.isSave
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: {
                        size: "mini",
                        type: "primary",
                        disabled: _vm.isDisabled,
                      },
                      on: { click: _vm.onSave },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              _vm.isSubmit
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: {
                        size: "mini",
                        type: "primary",
                        disabled: _vm.isDisabled,
                      },
                      on: { click: _vm.onSubmit },
                    },
                    [_vm._v("提交")]
                  )
                : _vm._e(),
              _vm.isRelease
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onIssue },
                    },
                    [_vm._v("下发")]
                  )
                : _vm._e(),
              _vm.isShowButton
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onReject("Y")
                        },
                      },
                    },
                    [_vm._v("条件收货")]
                  )
                : _vm._e(),
              _vm.isShowButton
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onReject("N")
                        },
                      },
                    },
                    [_vm._v("拒收")]
                  )
                : _vm._e(),
              _vm.isAssistedDecision
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onCqsConfirm },
                    },
                    [_vm._v("邀请CQS协助判定")]
                  )
                : _vm._e(),
              _vm.isChecked
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onVerificationCompleted },
                    },
                    [_vm._v("核实完成")]
                  )
                : _vm._e(),
              _vm.isQues
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onNoObjection },
                    },
                    [_vm._v("无异议")]
                  )
                : _vm._e(),
              _vm.isQues
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onObjection },
                    },
                    [_vm._v("有异议")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "detailForm",
              attrs: {
                model: _vm.detailForm,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c("div", { staticClass: "within_box" }, [
                _c("div", { staticClass: "title_box" }, [
                  _c("p", { staticClass: "line" }),
                  _c("p", { staticClass: "title" }, [
                    _vm._v("Basic Information"),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "form_box" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "评价月", prop: "month" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: _vm.isDisabled,
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    on: { change: _vm.monthChange },
                                    model: {
                                      value: _vm.detailForm.month,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.detailForm, "month", $$v)
                                      },
                                      expression: "detailForm.month",
                                    },
                                  },
                                  _vm._l(
                                    _vm.monthOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: { label: item, value: item },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "QIP单据编号",
                                  prop: "qipCode",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    clearable: "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      _vm.detailForm.qipCode =
                                        _vm.detailForm.qipCode.toLocaleUpperCase()
                                    },
                                  },
                                  model: {
                                    value: _vm.detailForm.qipCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "qipCode", $$v)
                                    },
                                    expression: "detailForm.qipCode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "供应商名称",
                                  prop: "supplierName",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.supplierName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "supplierName",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.supplierName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "产品名称",
                                  prop: "eightBitCodeName",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.eightBitCodeName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "eightBitCodeName",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.eightBitCodeName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "产品类别",
                                  prop: "category2Name",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.category2Name,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "category2Name",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.category2Name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "不合格原因",
                                  prop: "causeOfNonconformity",
                                },
                              },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    clearable: "",
                                    table: "TT_QSPI_QIP",
                                    field: "CAUSE_OF_NONCONFORMITY",
                                    placeholder: "请选择",
                                  },
                                  on: {
                                    change: _vm.causeOfNonconformityChange,
                                  },
                                  model: {
                                    value: _vm.detailForm.causeOfNonconformity,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "causeOfNonconformity",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "detailForm.causeOfNonconformity",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "风险等级", prop: "riskGrade" },
                              },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    clearable: "",
                                    table: "TT_QSPI_QIP",
                                    field: "RISK_GRADE",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.detailForm.riskGrade,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "riskGrade", $$v)
                                    },
                                    expression: "detailForm.riskGrade",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "问题产品数量",
                                  prop: "quantity",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.quantity,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "quantity", $$v)
                                    },
                                    expression: "detailForm.quantity",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "单位", prop: "mcdBuyingUnit" },
                              },
                              [
                                _c("ic-select", {
                                  attrs: {
                                    disabled: "",
                                    table: "TM_MATERIAL_RECORD",
                                    field: "MCD_BUYING_UNIT",
                                  },
                                  model: {
                                    value: _vm.detailForm.mcdBuyingUnit,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "mcdBuyingUnit",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.mcdBuyingUnit",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "责任方",
                                  prop: "responsibleParty",
                                },
                              },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    clearable: "",
                                    table: "TT_QSPI_QIP",
                                    field: "RESPONSIBLE_PARTY",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.detailForm.responsibleParty,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "responsibleParty",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.responsibleParty",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "承运商", prop: "carrierCode" },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: _vm.isDisabled,
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.carrierCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "carrierCode",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.carrierCode",
                                    },
                                  },
                                  _vm._l(
                                    _vm.carrierCodeOptions,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.supplierCode,
                                        attrs: {
                                          label: item.supplierName,
                                          value: item.supplierCode,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "产品属性",
                                  prop: "temperature",
                                },
                              },
                              [
                                _c("ic-select", {
                                  attrs: {
                                    clearable: "",
                                    table: "COMMON",
                                    field: "TEMPERATURE",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.temperature,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "temperature",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.temperature",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "供应商编号",
                                  prop: "supplierCode",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.supplierCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "supplierCode",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.supplierCode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "QIP日期", prop: "qipDate" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    type: "date",
                                    "value-format": "yyyy-MM-dd",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.detailForm.qipDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "qipDate", $$v)
                                    },
                                    expression: "detailForm.qipDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "产品生产日期",
                                  prop: "productionDate",
                                },
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    type: "date",
                                    "value-format": "yyyy-MM-dd",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.detailForm.productionDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "productionDate",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.productionDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "产品编号",
                                  prop: "eightBitCode",
                                },
                              },
                              [
                                !_vm.isDisabled
                                  ? _c(
                                      "el-input",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: { readonly: "" },
                                        model: {
                                          value: _vm.detailForm.eightBitCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.detailForm,
                                              "eightBitCode",
                                              $$v
                                            )
                                          },
                                          expression: "detailForm.eightBitCode",
                                        },
                                      },
                                      [
                                        _c("el-button", {
                                          attrs: {
                                            slot: "append",
                                            icon: "el-icon-search",
                                          },
                                          on: { click: _vm.showDetail },
                                          slot: "append",
                                        }),
                                      ],
                                      1
                                    )
                                  : _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { disabled: _vm.isDisabled },
                                      model: {
                                        value: _vm.detailForm.eightBitCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "eightBitCode",
                                            $$v
                                          )
                                        },
                                        expression: "detailForm.eightBitCode",
                                      },
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "发现环节",
                                  prop: "discoveryLink",
                                },
                              },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    clearable: "",
                                    table: "TT_QSPI_QIP",
                                    field: "DISCOVERY_LINK",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.detailForm.discoveryLink,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "discoveryLink",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.discoveryLink",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "处理方式",
                                  prop: "processingMode",
                                },
                              },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    clearable: "",
                                    table: "TT_QSPI_QIP",
                                    field: "PROCESSING_MODE",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.detailForm.processingMode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "processingMode",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.processingMode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "DC编号", prop: "dcCode" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: _vm.isDisabled,
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    on: { change: _vm.dcCodeChange },
                                    model: {
                                      value: _vm.detailForm.dcCode,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.detailForm, "dcCode", $$v)
                                      },
                                      expression: "detailForm.dcCode",
                                    },
                                  },
                                  _vm._l(
                                    _vm.dcCodeLists,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.dcCode,
                                          value: item.dcCode,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "订单编号", prop: "orderNo" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.orderNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "orderNo", $$v)
                                    },
                                    expression: "detailForm.orderNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "批准方", prop: "approver" } },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    clearable: "",
                                    table: "TT_QSPI_QIP",
                                    field: "APPROVER",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.detailForm.approver,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "approver", $$v)
                                    },
                                    expression: "detailForm.approver",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "CQS特批",
                                  prop: "cqsSpecialApprover",
                                },
                              },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    clearable: "",
                                    table: "TT_QSPI_QIP",
                                    field: "CQS_SPECIAL_APPROVER",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.detailForm.cqsSpecialApprover,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "cqsSpecialApprover",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.cqsSpecialApprover",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Facility名称",
                                  prop: "facilityName",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.facilityName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "facilityName",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.facilityName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态", prop: "status" } },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: "",
                                    table: "TT_QSPI_QIP",
                                    field: "STATUS",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.detailForm.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "status", $$v)
                                    },
                                    expression: "detailForm.status",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "备注", prop: "remarks" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    type: "textarea",
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    autosize: { minRows: 4, maxRows: 6 },
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.remarks,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "remarks", $$v)
                                    },
                                    expression: "detailForm.remarks",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.ms_roles.indexOf("QSPI_QIP_OWNER") !== -1
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "QIP_Owner备注",
                                      prop: "ownerRemarks",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.isDisabled,
                                        type: "textarea",
                                        maxlength: "1000",
                                        "show-word-limit": "",
                                        autosize: { minRows: 4, maxRows: 6 },
                                        placeholder: "请输入内容",
                                      },
                                      model: {
                                        value: _vm.detailForm.ownerRemarks,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "ownerRemarks",
                                            $$v
                                          )
                                        },
                                        expression: "detailForm.ownerRemarks",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm.isMcdFlag && _vm.detailForm.dataSource === "QMS"
                ? _c("div", { staticClass: "within_box" }, [
                    _c("div", { staticClass: "title_box" }, [
                      _c("p", { staticClass: "line" }),
                      _c("p", { staticClass: "title" }, [
                        _vm._v("QMS原始信息"),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "form_box" },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "QIP报告属性",
                                      prop: "qipReportAttributes",
                                    },
                                  },
                                  [
                                    _c("ic-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        disabled: true,
                                        clearable: "",
                                        table: "TT_QSPI_QIP",
                                        field: "QIP_REPORT_ATTRIBUTES",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value:
                                          _vm.detailForm.qipReportAttributes,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "qipReportAttributes",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "detailForm.qipReportAttributes",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "DC_QS处理方式",
                                      prop: "qmsProcessingMode",
                                    },
                                  },
                                  [
                                    _c("ic-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        disabled: true,
                                        clearable: "",
                                        table: "TT_QSPI_QIP",
                                        field: "PROCESSING_MODE",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value: _vm.detailForm.qmsProcessingMode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "qmsProcessingMode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "detailForm.qmsProcessingMode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "处理建议",
                                      prop: "qipProcessingModeSuggestion",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          placement: "top",
                                          content:
                                            _vm.detailForm
                                              .qipProcessingModeSuggestion,
                                          disabled: _vm.showTooltip,
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            disabled: true,
                                            clearable: "",
                                          },
                                          nativeOn: {
                                            mouseover: function ($event) {
                                              return _vm.inputOnMouseOver(
                                                $event
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.detailForm
                                                .qipProcessingModeSuggestion,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.detailForm,
                                                "qipProcessingModeSuggestion",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "detailForm.qipProcessingModeSuggestion",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "不合格原因",
                                      prop: "qmsCauseOfNonconformity",
                                    },
                                  },
                                  [
                                    _c("ic-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        disabled: true,
                                        clearable: "",
                                        table: "TT_QSPI_QIP",
                                        isShowTooltip: true,
                                        field: "CAUSE_OF_NONCONFORMITY",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value:
                                          _vm.detailForm
                                            .qmsCauseOfNonconformity,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "qmsCauseOfNonconformity",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "detailForm.qmsCauseOfNonconformity",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "风险等级",
                                      prop: "qmsRiskGrade",
                                    },
                                  },
                                  [
                                    _c("ic-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        disabled: true,
                                        clearable: "",
                                        table: "TT_QSPI_QIP",
                                        field: "RISK_GRADE",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value: _vm.detailForm.qmsRiskGrade,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "qmsRiskGrade",
                                            $$v
                                          )
                                        },
                                        expression: "detailForm.qmsRiskGrade",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _vm.ms_emplFlag !== "SUP"
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "责任方是否已确认",
                                          prop: "responsibleConfirm",
                                        },
                                      },
                                      [
                                        _c("ic-select", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            disabled: _vm.isRelease
                                              ? false
                                              : true,
                                            clearable: "",
                                            table: "TT_QSPI_QIP",
                                            field: "RESPONSIBLE_CONFIRM",
                                            placeholder: "请选择",
                                          },
                                          model: {
                                            value:
                                              _vm.detailForm.responsibleConfirm,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.detailForm,
                                                "responsibleConfirm",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "detailForm.responsibleConfirm",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "责任方",
                                      prop: "qmsResponsibleParty",
                                    },
                                  },
                                  [
                                    _c("ic-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        disabled: true,
                                        clearable: "",
                                        table: "TT_QSPI_QIP",
                                        field: "PROCESSING_MODE",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value:
                                          _vm.detailForm.qmsResponsibleParty,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "qmsResponsibleParty",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "detailForm.qmsResponsibleParty",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "提供调查报告",
                                      prop: "investigationReportsFlag",
                                    },
                                  },
                                  [
                                    _c("ic-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        disabled: true,
                                        clearable: "",
                                        table: "TT_QSPI_QIP",
                                        field: "RESPONSIBLE_CONFIRM",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value:
                                          _vm.detailForm
                                            .investigationReportsFlag,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "investigationReportsFlag",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "detailForm.investigationReportsFlag",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "货品温度",
                                      prop: "productTemperature",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { disabled: true, clearable: "" },
                                      model: {
                                        value:
                                          _vm.detailForm.productTemperature,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "productTemperature",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "detailForm.productTemperature",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "问题产品数量",
                                      prop: "qmsQuantity",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { disabled: true, clearable: "" },
                                      model: {
                                        value: _vm.detailForm.qmsQuantity,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "qmsQuantity",
                                            $$v
                                          )
                                        },
                                        expression: "detailForm.qmsQuantity",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "到货箱数",
                                      prop: "arriveBox",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { disabled: true, clearable: "" },
                                      model: {
                                        value: _vm.detailForm.arriveBox,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "arriveBox",
                                            $$v
                                          )
                                        },
                                        expression: "detailForm.arriveBox",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "检测箱数",
                                      prop: "detectionBox",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { disabled: true, clearable: "" },
                                      model: {
                                        value: _vm.detailForm.detectionBox,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "detectionBox",
                                            $$v
                                          )
                                        },
                                        expression: "detailForm.detectionBox",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "车厢连续温度是否合格",
                                      prop: "vehicleTemperature",
                                    },
                                  },
                                  [
                                    _c("ic-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        disabled: true,
                                        clearable: "",
                                        table: "TT_QSPI_QIP",
                                        field: "RESPONSIBLE_CONFIRM",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value:
                                          _vm.detailForm.vehicleTemperature,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "vehicleTemperature",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "detailForm.vehicleTemperature",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 18 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "QIP情况描述",
                                      prop: "qipDescription",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: true,
                                        type: "textarea",
                                        maxlength: "1000",
                                        "show-word-limit": "",
                                        autosize: { minRows: 2, maxRows: 6 },
                                        placeholder: "",
                                      },
                                      model: {
                                        value: _vm.detailForm.qipDescription,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "qipDescription",
                                            $$v
                                          )
                                        },
                                        expression: "detailForm.qipDescription",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              (_vm.isMcdFlag &&
                _vm.detailForm.dataSource === "QMS" &&
                !(
                  !_vm.detailForm.cqsProcessingMode &&
                  _vm.ms_roles.indexOf("QSPI_QIP_CQS") > -1
                )) ||
              _vm.isShowButton
                ? _c("div", { staticClass: "within_box" }, [
                    _c("div", { staticClass: "title_box" }, [
                      _c("p", { staticClass: "line" }),
                      _c("p", { staticClass: "title" }, [
                        _vm._v("处理方式判定"),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "form_box" },
                      [
                        _vm.detailForm.fscProcessingMode ||
                        _vm.detailForm.fscFeedbackStatus != "TO_BE_ISSUED"
                          ? _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "FSC处理方式",
                                          prop: "fscProcessingMode",
                                        },
                                      },
                                      [
                                        _c("ic-select", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            disabled: true,
                                            clearable: "",
                                            table: "TT_QSPI_QIP",
                                            field: "PROCESSING_MODE",
                                            placeholder: "请选择",
                                          },
                                          model: {
                                            value:
                                              _vm.detailForm.fscProcessingMode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.detailForm,
                                                "fscProcessingMode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "detailForm.fscProcessingMode",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.detailForm.fscProcessingMode ||
                        _vm.detailForm.fscFeedbackStatus != "TO_BE_ISSUED"
                          ? _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "FSC处理意见",
                                          prop: "fullFscProcessingModeComments",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled: true,
                                            type: "textarea",
                                            maxlength: "1000",
                                            "show-word-limit": "",
                                            autosize: {
                                              minRows: 2,
                                              maxRows: 6,
                                            },
                                            placeholder: "请输入FSC处理意见",
                                          },
                                          model: {
                                            value:
                                              _vm.detailForm
                                                .fullFscProcessingModeComments,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.detailForm,
                                                "fullFscProcessingModeComments",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "detailForm.fullFscProcessingModeComments",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.detailForm.cqsProcessingMode ||
                        _vm.detailForm.fscFeedbackStatus == "TO_BE_CQS_ISSUED"
                          ? _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "CQS建议处理",
                                          prop: "cqsProcessingMode",
                                        },
                                      },
                                      [
                                        _c("ic-select", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            disabled: true,
                                            clearable: "",
                                            table: "TT_QSPI_QIP",
                                            field: "PROCESSING_MODE",
                                            placeholder: "请选择",
                                          },
                                          model: {
                                            value:
                                              _vm.detailForm.cqsProcessingMode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.detailForm,
                                                "cqsProcessingMode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "detailForm.cqsProcessingMode",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.detailForm.cqsProcessingMode ||
                        _vm.detailForm.fscFeedbackStatus == "TO_BE_CQS_ISSUED"
                          ? _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "CQS处理意见",
                                          prop: "cqsProcessingModeSuggestion",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled: true,
                                            type: "textarea",
                                            maxlength: "1000",
                                            "show-word-limit": "",
                                            autosize: {
                                              minRows: 2,
                                              maxRows: 6,
                                            },
                                            placeholder: "请输入CQS处理意见",
                                          },
                                          model: {
                                            value:
                                              _vm.detailForm
                                                .cqsProcessingModeSuggestion,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.detailForm,
                                                "cqsProcessingModeSuggestion",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "detailForm.cqsProcessingModeSuggestion",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "within_box" }, [
                _c("div", { staticClass: "title_box" }, [
                  _c("p", { staticClass: "line" }),
                  _c("p", { staticClass: "title" }, [_vm._v("反馈信息")]),
                ]),
                _c("div", { staticClass: "form_box" }, [
                  _c("table", { staticClass: "table-d" }, [
                    _c("tr", [
                      _c("td", [_vm._v("反馈结果")]),
                      _c("td", [
                        _vm._v(_vm._s(_vm.detailForm.feedbackResults)),
                      ]),
                      _c("td", [_vm._v("建议责任方")]),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.detailForm.proposeResponsiblePartyI18n)
                        ),
                      ]),
                      _c("td", [_vm._v("反馈方")]),
                      _c("td", [_vm._v(_vm._s(_vm.detailForm.feedbackParty))]),
                    ]),
                    _c("tr", [
                      _c("td", [_vm._v("核实截止时间")]),
                      _c("td", [_vm._v(_vm._s(_vm.detailForm.closingDate))]),
                      _c("td", [_vm._v("理由")]),
                      _c("td", [_vm._v(_vm._s(_vm.detailForm.reason))]),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            { staticClass: "tab_box" },
            [
              _c(
                "el-tabs",
                { attrs: { type: "border-card" } },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "附件" } },
                    [
                      _vm.isShow
                        ? _c(
                            "el-row",
                            { staticStyle: { "margin-bottom": "5px" } },
                            [
                              _c(
                                "el-upload",
                                {
                                  ref: "upload",
                                  attrs: {
                                    action: "upload",
                                    "http-request": _vm.uploadConfirm,
                                    "show-file-list": false,
                                    multiple: "",
                                    name: "file",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        slot: "trigger",
                                        size: "small",
                                        type: "primary",
                                      },
                                      slot: "trigger",
                                    },
                                    [_vm._v("上传")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-table",
                        {
                          ref: "plxTable1",
                          attrs: {
                            data: _vm.tableData1,
                            "max-height": "500",
                            border: "",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _vm.isShow
                            ? _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: "操作",
                                  width: "80",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm.ms_userId === scope.row.createBy
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onDel(
                                                        scope.row.tmDocumentId,
                                                        scope.$index,
                                                        _vm.tableData1,
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("删除")]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1973551503
                                ),
                              })
                            : _vm._e(),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "文件名称",
                              prop: "documentName",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDownload(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row.documentName))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "上传人",
                              prop: "userName",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "上传时间",
                              prop: "createDate",
                              "show-overflow-tooltip": "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "图片" } },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "problemProductPhotoRef",
                          class: { hide: _vm.disableEditor },
                          attrs: {
                            accept:
                              ".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP",
                            disabled: _vm.disableEditor,
                            multiple: "",
                            "list-type": "picture-card",
                            action: "upload",
                            "file-list": _vm.problemProductPhotoList,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "file",
                              fn: function ({ file }) {
                                return _c(
                                  "div",
                                  { staticStyle: { height: "100%" } },
                                  [
                                    _c("img", {
                                      attrs: {
                                        width: "100%",
                                        height: "100%",
                                        src: file.url,
                                        alt: "",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "el-upload-list__item-actions",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "el-upload-list__item-preview",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleProblemProductPreview(
                                                  file
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-zoom-in",
                                            }),
                                          ]
                                        ),
                                        file.tmDocumentId
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-list__item-delete",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.downloadFile(
                                                      file
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-download",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              },
                            },
                          ]),
                        },
                        [_c("i", { staticClass: "el-icon-plus" })]
                      ),
                      _c(
                        "el-dialog",
                        {
                          staticClass: "enlargePhoto",
                          attrs: { visible: _vm.problemProductDialogVisible },
                          on: {
                            "update:visible": function ($event) {
                              _vm.problemProductDialogVisible = $event
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              width: "100%",
                              src: _vm.problemProductImageUrl,
                              alt: "",
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "操作日志" } },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "plxTable2",
                          attrs: {
                            data: _vm.tableData2,
                            "max-height": "500",
                            border: "",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作时间",
                              prop: "createDate",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作人",
                              prop: "operatorName",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作描述",
                              prop: "comments",
                              "show-overflow-tooltip": "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "产品名称选择",
            visible: _vm.dialogProVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogProVisible = $event
            },
            close: _vm.onClosePro,
          },
        },
        [
          _vm.dialogProVisible
            ? _c("selMaterial", { on: { setSelPro: _vm.setSelPro } })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "维护异议",
            visible: _vm.dialogObjectVisible,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogObjectVisible = $event
            },
            close: _vm.onCloseObject,
          },
        },
        [
          _vm.dialogObjectVisible
            ? _c("feedback-Dialog", {
                attrs: {
                  userId: _vm.ms_userId,
                  id: _vm.ttQspiQipId,
                  form: _vm.form,
                },
                on: {
                  onCloseObject1: _vm.onCloseObject1,
                  onCloseObject: _vm.onCloseObject,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.dialogTit === "Y"
                ? "条件收货"
                : this.dialogTit == "N"
                ? "拒收"
                : "邀请CQS协助判定",
            visible: _vm.dialogReVisable,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogReVisable = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "qmsForm",
                  attrs: { model: _vm.qmsForm, "label-width": "100px" },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "处理意见",
                                prop: "processingModeSuggestion",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  maxlength: "1000",
                                  "show-word-limit": "",
                                  autosize: { minRows: 4, maxRows: 6 },
                                  placeholder: "请输入内容",
                                },
                                model: {
                                  value: _vm.qmsForm.processingModeSuggestion,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.qmsForm,
                                      "processingModeSuggestion",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "qmsForm.processingModeSuggestion",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { type: "flex", justify: "center" },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.saveConfirm },
                    },
                    [_vm._v("保存")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.dialogReVisable = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }